import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { auth } from '../firebase/FirebaseConfig';
import { getUserInfo } from '../firebase/FirebaseManagement';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [account, setAccount] = useState();
    const location = useLocation();
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUser(user)
        
            } else {
                setUser(undefined)
                navigate('/login')
            }
        });

        return () => unsubscribe();
    }, [])

    const fetchUserInfo = async () => {
        var userId = localStorage.getItem('userId')
        var userInfo = await getUserInfo(userId)
        if (userInfo) {
            setAccount(userInfo)
        }
    }

    useEffect(()=> {
        fetchUserInfo()
    },[])

    const isCreateRide = location.pathname === '/create-ride';

    if(!isCreateRide && !account) {
        navigate('/login');
    }

    if (user) {
        return children;
      } else {
        return null;
      }
};

export default ProtectedRoute;